module.exports = __webpack_public_path__ + "img/webapp.44607427.png";